<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <PublicPageHeader />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <div class="blog-page">
                                                            <article id="post-inner">
                                                                <header class="article-header">
                                                                    <h1 class="section-header with-divider">ご利用手数料について
                                                                    </h1>
                                                                    <ul class="post-data">
                                                                        <li class="posted"><span
                                                                                class="data-h">POSTED&nbsp;:&nbsp;&nbsp;</span>2014.01.20
                                                                        </li>
                                                                    </ul>
                                                                    <sns-share-links />
                                                                    <div class="eyecatch-img">
                                                                        <span><img width="860" height="480"
                                                                                src="@/assets/img/static_pages/fukidashi_7_20131219.jpg"
                                                                                class="attachment-w860-h480 size-w860-h480 wp-post-image"
                                                                                alt="fukidashi_7_20131219"></span>
                                                                    </div>
                                                                </header>

                                                                <!-- post -->
                                                                <section class="article-content">
                                                                    <p>hubsynchユーザーアカウントのご利用についての手数料は下記の通りです。</p>
                                                                    <h2>hubsynchユーザーアカウント</h2>
                                                                    <ul>
                                                                        <li><span
                                                                                style="color: #252122; font-size: 18px; font-weight: bold; line-height: 32px;">アカウントの開設費/維持費：無料</span>
                                                                        </li>
                                                                        <li><span
                                                                                style="color: #252122; font-size: 18px; font-weight: bold; line-height: 32px;">国内での商品・サービスのご購入におけるご利用：無料</span>
                                                                        </li>
                                                                    </ul>
                                                                    <div class="hubsynch-index-block">
                                                                        <h3 class="hubsynch-index-title">hubsynchについて
                                                                        </h3>
                                                                        <nav class="hubsynch-index-menu below-title">
                                                                            <ul>
                                                                                <li><router-link title="hubsynchってなに？"
                                                                                        :to="{ name: 'about.hubsynch' }">hubsynchってなに？</router-link>
                                                                                </li>
                                                                                <li><router-link title="アカウントの種類について"
                                                                                        :to="{ name: 'category.account' }">アカウントの種類について</router-link>
                                                                                </li>
                                                                                <li><router-link title="hubsynchの特長"
                                                                                        :to="{ name: 'hubsynch.strong.point' }">hubsynchの特長</router-link>
                                                                                </li>
                                                                                <li><router-link title="hubsynchのご利用方法"
                                                                                        :to="{ name: 'hubsynch.using' }">hubsynchのご利用方法</router-link>
                                                                                </li>
                                                                                <li><router-link title="hubsynchのしくみ"
                                                                                        :to="{ name: 'hubsynch.flow' }">hubsynchのしくみ</router-link>
                                                                                </li>
                                                                                <li><router-link title="ユーザーアカウントの登録方法"
                                                                                        :to="{ name: 'how.to.sign.up' }">ユーザーアカウントの登録方法</router-link>
                                                                                </li>
                                                                                <li><router-link class="active"
                                                                                        title="ご利用手数料について"
                                                                                        :to="{ name: 'user.account.fee' }">ご利用手数料について</router-link>
                                                                                </li>
                                                                            </ul>
                                                                        </nav>
                                                                    </div>
                                                                </section>
                                                                <!-- -->

                                                                <!-- btn-contact -->
                                                                <div id="btn-contact-wrap" class="btn-wrap">
                                                                    <p class="txt">ご不明な点がございましたら、お問い合わせください</p>
                                                                    <p class="btn"><router-link
                                                                            :to="{ name: 'contact.us' }">お問合せ</router-link>
                                                                    </p>
                                                                </div>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>
</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>